var map = {
	"./Equipa_Ergon_1.png": "d9e8",
	"./Equipa_Ergon_2.png": "84b7",
	"./Equipa_PS_1.png": "7bd5",
	"./Equipa_PS_2.png": "1d35",
	"./Equipa_Seg_1.png": "a213",
	"./Equipa_Seg_2.png": "e09f",
	"./Equipa_Sinal_1.png": "72a1",
	"./Equipa_Sinal_2.png": "6995",
	"./bft.png": "68e8",
	"./dev_app.png": "0553",
	"./docs.png": "eab0",
	"./game_show.png": "7973",
	"./hipnose.png": "5d33",
	"./laboral.png": "8ae7",
	"./logo_scopos.png": "543c",
	"./logo_scopos_branco.png": "84b6",
	"./logo_scopos_branco_.png": "8206",
	"./magica.png": "2134",
	"./music.png": "dc44",
	"./palestra.png": "0e96",
	"./parodia.png": "8db5",
	"./pecas.png": "9944",
	"./protection.png": "1851",
	"./quick_massage.png": "9fd5",
	"./sipat.png": "4ecd",
	"./stand_up.png": "4e4f",
	"./talk_show.png": "2d67",
	"./teatro.png": "f2ed",
	"./training.png": "f0a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";